import { Card } from 'semantic-ui-react';
import './Loginpagestyle.css';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function CustomerCard() {
  const history = useNavigate();

  const routingCard = () => {
    history('/TemplateList');
  };

  return (
    <>
      <div className="CustomerCard-Container" style={{ marginRight: '10%' }}>
        <Card.Group style={{ height: '550px' }}>
          <Card className="CustomerCard-Container-card" onClick={routingCard}>
            <Card.Content>
              <Card.Header style={{ color: 'rgba(0,0,0,.85);' }}>
                Vault Management System
              </Card.Header>
              <br />
              <span>
                {' '}
                Vault Management System aims at providing a comprehensive
                application for physical assets management, starting from
                acquisition of assets, regular maintenance, storage, backup,
                movement tracking to logistics, and making the archivist life
                easy
              </span>
            </Card.Content>
          </Card>
          <Card
            className="CustomerCard-Container-card"
            onClick={() =>
              toast.error('Film Scanning / Digitization  is not available')
            }
          >
            <Card.Content>
              <Card.Header style={{ color: 'black' }}>
                Film Scanning / Digitization
              </Card.Header>
              <br />
              <span>
                Film Scanning is in our DNA considering we have 6 plus decades
                of excellence behind us supporting the unique concept of Script
                to Screen that we have offered our clients
              </span>
            </Card.Content>
          </Card>
          <Card
            className="CustomerCard-Container-card"
            onClick={() => toast.error('Restoration  is not available')}
          >
            <Card.Content>
              <Card.Header style={{ color: 'black' }}>Restoration </Card.Header>
              <br />
              <span>
                <span>
                  Customized solution across pristine restoration or a
                  combination of Auto & Manual based on client requirement
                  Picture/Image Restoration from Standard Definition (SD) up to
                  8K format Sound restoration from Mono to 5.1 Dolby digital{' '}
                </span>
              </span>
            </Card.Content>
          </Card>
          <Card
            className="CustomerCard-Container-card"
            onClick={() =>
              toast.error('SDR to HDR Conversion  is not available')
            }
          >
            <Card.Content>
              <Card.Header style={{ color: 'black' }}>
                SDR to HDR Conversion
              </Card.Header>
              <br />
              <span>
                With the rise of Over-The-Top (OTT) platforms the way we consume
                video content has changed dramatically. So have the expectations
                of the viewers. Today, consumers expect nothing less than the
                best when it comes to picture quality, and that's where the need
                for SDR to HDR conversion comes in
              </span>
            </Card.Content>
          </Card>
          <Card
            className="CustomerCard-Container-card"
            onClick={() =>
              toast.error('Digital Deliverables  is not available')
            }
          >
            <Card.Content>
              <Card.Header style={{ color: 'black' }}>
                {' '}
                Digital Deliverables
              </Card.Header>
              <br />
              <span>
                Prasad Corp provides Digitization and Restoration of Archival
                material whether it be Celluloid Film, Videotapes, Still Images
                and Documents. Our digitised outputs cater to the huge demand
                for emerging technologies, Digital Cinema, HD Broadcast,
                Web-based Applications and OTT platforms.
              </span>
            </Card.Content>
          </Card>
          <Card
            className="CustomerCard-Container-card"
            onClick={() =>
              toast.error('Video and Tape Digitization  is not available')
            }
          >
            <Card.Content>
              <Card.Header style={{ color: 'black' }}>
                Video and Tape Digitization
              </Card.Header>
              <br />
              <span>
                Prasad Corp introduced Digitization services in the 1980s and
                since then has been serving all Terrestrial, Satellite and
                Broadcast channels the region. We have digitized more than
                600000 hours of film content over the last 2 plus decades.
              </span>
            </Card.Content>
          </Card>
        </Card.Group>
      </div>
    </>
  );
}
